export class Reseller {

  constructor(name, address, contactNumber, email, abn) {
    this.name = name
    this.address = address
    this.contactNumber = contactNumber
    this.email = email
    this.abn = abn
  }
}